import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";
import styles from "./RolePicker.module.css";

export default function RolePicker() {
  const navigate = useNavigate();
  const token = useAuthStore((s) => s.token);

  return (
    <div className={styles.stage}>
      <div className={styles.stars} aria-hidden />
      <div className={styles.header}>
        <div className={styles.logo}>Star<em>Quest</em></div>
        <div className={styles.sub}>Every chore is a quest. Every quest earns a star.</div>
      </div>

      <div className={styles.cards}>
        <button
          className={`${styles.card} ${styles.parent}`}
          onClick={() => navigate(token ? "/parent" : "/login")}
        >
          <div className={styles.pic}>👨‍💼</div>
          <div>
            <div className={styles.cardTitle}>Quest Master</div>
            <div className={styles.cardDesc}>Create quests, hide stars, verify completions, control the bank.</div>
          </div>
          <span className={styles.go}>Enter Command Center →</span>
        </button>

        <button
          className={`${styles.card} ${styles.kid}`}
          onClick={() => navigate("/kid")}
        >
          <div className={styles.pic}>🧑‍🚀</div>
          <div>
            <div className={styles.cardTitle}>Explorer</div>
            <div className={styles.cardDesc}>Find hidden stars, complete quests, earn rewards!</div>
          </div>
          <span className={styles.go}>Start Exploring →</span>
        </button>
      </div>

      <div className={styles.footer}>STARQUEST · FAMILY EDITION</div>
    </div>
  );
}
